import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthToken = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

// Get all course categories for the customer
export const getCourseCategories = async () => {
    const response = await axios.get(`${API_URL}/course-categories`, getAuthToken());
    return response.data;
};

// Get all courses for the customer (with optional category filter)
export const getCourses = async (categoryId = null) => {
    const params = {};
    if (categoryId) {
        params.category_id = categoryId;
    }
    const response = await axios.get(`${API_URL}/courses`, { ...getAuthToken(), params });
    return response.data;
};

// Create a new course
export const createCourse = async (courseData) => {
    const response = await axios.post(`${API_URL}/courses`, courseData, getAuthToken());
    return response.data;
};

// Update an existing course
export const updateCourse = async (courseId, courseData) => {
    const response = await axios.put(`${API_URL}/courses/${courseId}`, courseData, getAuthToken());
    return response.data;
};

// Delete a course
export const deleteCourse = async (courseId) => {
    const response = await axios.delete(`${API_URL}/courses/${courseId}`, getAuthToken());
    return response.data;
};

// Create a new course category
export const createCourseCategory = async (categoryData) => {
    const response = await axios.post(`${API_URL}/course-categories`, categoryData, getAuthToken());
    return response.data;
};

// Update a course category
export const updateCourseCategory = async (categoryId, categoryData) => {
    const response = await axios.put(`${API_URL}/course-categories/${categoryId}`, categoryData, getAuthToken());
    return response.data;
};

// Delete a course category
export const deleteCourseCategory = async (categoryId) => {
    const response = await axios.delete(`${API_URL}/course-categories/${categoryId}`, getAuthToken());
    return response.data;
};
